// ─────────────────────────────────────────────
// KLOTHIQ — Payment Zod Schemas
// ─────────────────────────────────────────────

import { z } from 'zod';
import { PaymentMethod, PaymentType } from '@klothiq/domain';
import { moneySchema, dateSchema } from './common.schema';

export const paymentFormSchema = z
  .object({
    payment_type: z.nativeEnum(PaymentType),
    sale_id: z.string().uuid().nullable().optional(),
    purchase_id: z.string().uuid().nullable().optional(),
    account_id: z.string().uuid('Select a cash account'),
    amount: moneySchema.refine((val) => parseFloat(val) > 0, 'Amount must be greater than zero'),
    payment_method: z.nativeEnum(PaymentMethod),
    payment_date: dateSchema,
    reference_number: z.string().max(100).nullable().optional(),
    notes: z.string().max(500).nullable().optional(),
  })
  .refine(
    (data) => {
      // Must have either sale_id or purchase_id (not both)
      if (
        data.payment_type === PaymentType.SALE_PAYMENT ||
        data.payment_type === PaymentType.REFUND
      ) {
        return !!data.sale_id;
      }
      if (data.payment_type === PaymentType.PURCHASE_PAYMENT) {
        return !!data.purchase_id;
      }
      return true;
    },
    {
      message: 'Payment must be linked to a sale or purchase',
      path: ['sale_id'],
    },
  );

export type PaymentFormValues = z.infer<typeof paymentFormSchema>;
